import { render } from "./MultipleMyelomaSampleView.vue?vue&type=template&id=3898c68f"
import script from "./MultipleMyelomaSampleView.vue?vue&type=script&lang=js"
export * from "./MultipleMyelomaSampleView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__